import {
  embeddedSessionNoticeColors,
  embeddedSessionWaitingMessage,
  type ManualSaveHint,
} from '@tl4k/frontend-shared';

type Props = {
  /** Nome dell'app come lo legge la classe, es. `Disegna`. */
  appLabel: string;
  /** Testo esplicito, se serve una formulazione diversa da quella standard. */
  message?: string;
  /** App con salvataggio a richiesta: il testo nomina il pulsante (catalogo condiviso). */
  manualSave?: ManualSaveHint;
  testId?: string;
  className?: string;
};

/**
 * Barra di attesa **non bloccante** per le app dentro TechyWeb: la sessione
 * derivata dall'incontro non esiste ancora (il docente non ha ancora aperto
 * l'app) ma l'app resta usabile in locale e quello che si fa nell'attesa si
 * salva all'ingresso in sessione.
 *
 * Regola: `docs/standards/TL4K_EMBEDDED_APP_BOOT.md` § UI attesa. Sostituisce la
 * schermata bloccante `EmbeddedSessionWaiting`, che lasciava l'app inutilizzabile.
 */
export function EmbeddedSessionWaitingBanner({
  appLabel,
  message,
  manualSave,
  testId = 'session-waiting-banner',
  className = '',
}: Props) {
  const colors = embeddedSessionNoticeColors('waiting');
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={testId}
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flex: '0 0 auto',
        padding: '8px 14px',
        borderBottom: `1px solid ${colors.border}`,
        background: colors.background,
        color: colors.color,
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <span
        aria-hidden
        className="animate-spin"
        style={{
          flex: '0 0 auto',
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: '2px solid currentColor',
          borderTopColor: 'transparent',
        }}
      />
      <span style={{ flex: 1 }}>
        {message ?? embeddedSessionWaitingMessage(appLabel, manualSave)}
      </span>
    </div>
  );
}
